// extracted by mini-css-extract-plugin
export default {"cls1":"VeloLabelledItem-SkeletonContainer_cls1__na6LQ","cls2":"VeloLabelledItem-SkeletonContainer_cls2__vCiYo VeloLabelledItem-SkeletonContainer_cls1__na6LQ"};